const giftsToNotAddBack = []
const addedUpsells = [];
async function addGiftItems(cart){
    console.log(cart);
	const giftArr = [];
	const addItems = [];
	const giftFormRemove = {
		updates: {}
	};
	document.querySelectorAll('.gift-id-data-custom').forEach(gift => {
		giftArr.push({
			giftName: gift.dataset.giftname,
			freeAt: gift.dataset.freeat === 'null' ? null : parseInt(gift.dataset.freeat) * 100,
			giftId: gift.dataset.giftid === 'null' ? 'shipping' : parseInt(gift.dataset.giftid),
			variantId: gift.dataset.variantid === 'null' ? 'shipping' : parseInt(gift.dataset.variantid)
		})
	});
	const res = cart;
	const cartTotal = res.total_price;
	const itemsInCart = res.items;
	for (let i = 0; i < giftArr.length; i++) {
		// cart total is greater than a "free at" tier price
		if (cartTotal >= giftArr[i].freeAt) {
			// if true, check if that gift is already in cart
			for (let j = 0; j < itemsInCart.length; j++) {
				if (giftArr[i].giftId === "shipping") break;
				if (giftArr[i].variantId === itemsInCart[j].id && itemsInCart[j].properties['_isGift'] == true) {
					// console.log(`The gift **${giftArr[i].giftName}** is already in the cart...doing nothing`)
					/* code to check if gift is causing the added pricing */
					if (cartTotal >= giftArr[i].freeAt) {
						if (itemsInCart[j].quantity > 1) {
							//make sure quantity stays 1  
							let removeItem = giftArr[i].variantId
							giftFormRemove.updates[removeItem] = 1;
						}
						break;
					} else {
						let removeItem = giftArr[i].variantId
						giftFormRemove.updates[removeItem] = 0
						break;
					}
					/* code to check if gift is causing the added pricing ends*/
				} else if (j === itemsInCart.length - 1) {
					addItems.push({
						"id": giftArr[i].variantId.toString(),
						"quantity": 1,
						"properties": {
							"_isGift": true,
							"_freeAt": giftArr[i].freeAt
						}
					})
				}
			}
			// cart total is less than "free at" tier price
		} else {
			for (let j = 0; j < itemsInCart.length; j++) {
				if (giftArr[i].variantId === itemsInCart[j].id && itemsInCart[j].properties['_isGift'] == true) {
					// console.log(`The gift **${giftArr[i].giftName}** is in the cart...and must be removed`)
					let removeItem = giftArr[i].variantId
					giftFormRemove.updates[removeItem] = 0
					break
				}
			}
		}
	}
	// add gift items when cart price is above threshold and there are items to be added 
	if (addItems.length > 0) {
		const giftFormAdd = {
			'items': addItems
		}
		await fetch(window.Shopify.routes.root + 'cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(giftFormAdd)
		}).then(function(response) {
			return response.json();
		}).then(function(cart) {
            document.dispatchEvent(new CustomEvent('cart:build', {}));
		})
	}
	// remove gift items when price is below threshold and there are items to be removed 
	if (Object.keys(giftFormRemove.updates).length > 0) {
		// console.log('...removing gift from cart')
		await fetch(window.Shopify.routes.root + 'cart/update.js', {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(giftFormRemove)
		}).then(function(response) {
			return response.json();
		}).then(function(cart) {
			document.dispatchEvent(new CustomEvent('cart:build', {}));
		})
	}
}
document.addEventListener('cart:updated', function(event) {
  var cart = event.detail.cart; // Access the cart object from the event
  console.log(cart, 'function'); 
  addGiftItems(cart);
});
document.addEventListener('ajaxProduct:added', function(e) {
  theme.cart.getCart().then(function(e){
    addGiftItems(e);
  })
});
$(document).on('click', '.apply-button', function() {
    var inputValue = $('#codeInput').val(); // Get the value of #codeInput
    
    // Perform GET request
    $.ajax({
        url: `https://anka-jewelry.com/discount/${inputValue}`,
        type: 'GET',
        success: function(response) {
            // Show the discount applied message on success
            $('.discount-applied-message').show();
        },
        error: function(error) {
            // Handle errors if necessary
            console.error("Error applying discount:", error);
        }
    });
});

////////// UTILITY /////////////////
async function checkCart() {
	const res = await fetch('/cart.js')
	const cart = await res.json()
	// console.log(cart)
	return cart
}
// document.addEventListener("cart:updated", async function(event) {
// 	var _a;
// 	let cartContent = null,
// 		html = "";
// 	if (event.detail && event.detail["cart"]) {
// 		cartContent = event.detail["cart"];
// 		html = event.detail["cart"]["sections"]["mini-cart"];
// 	}
// 	const fakeDiv = document.createElement("div");
// 	fakeDiv.innerHTML = html;
// 	// console.log(fakeDiv);
// 	if (document.querySelector('.custom-sale-game.pdp') != null) document.querySelector('.custom-sale-game.pdp').innerHTML = fakeDiv.querySelector('.custom-sale-game').innerHTML;
// });